export default __webpack_public_path__ + "static/media/new-remote-web.6fbce580.png";